<template>
  <div class="download">
    <banner title="联系我们" subtitle="CONTACT US" />
    <div class="contact-panel" v-loading="loading">
      <div class="contact-grid">
        <div class="contact-card" v-for="item in contactItems" :key="item.label">
          <i :class="item.icon"></i>
          <div>
            <h3>{{ item.label }}</h3>
            <p>{{ item.value }}</p>
          </div>
        </div>
      </div>
      <div class="contact-map-like">
        <h3>欢迎咨询合作</h3>
        <p>无人机航测、三维建模、行业巡检、UTC培训与地理信息解决方案</p>
        <a class="phone-btn" :href="'tel:' + phone">立即拨打 {{ phone }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      phone: "400-871-5117",
      contactItems: [
        { label: "服务热线", value: "400-871-5117", icon: "el-icon-phone-outline" },
        { label: "移动电话", value: "13907488371", icon: "el-icon-mobile-phone" },
        { label: "传真", value: "0731-84220628", icon: "el-icon-printer" },
        { label: "邮箱", value: "zhuxingyuan010@vip.com", icon: "el-icon-message" },
        {
          label: "地址",
          value: "湖南省长沙市高新开发区岳麓西大道588号芯城科技园8栋501",
          icon: "el-icon-location-outline"
        }
      ]
    };
  },
  mounted() {
    this.$http
      .get("DataDictionary")
      .then(response => {
        const map = {};
        (response.data || []).forEach(i => {
          if (i && i.Key) map[i.Key] = i.Content;
        });
        if (map.ContactPhone) {
          this.phone = map.ContactPhone;
          this.contactItems[0].value = map.ContactPhone;
        }
        if (map.ContactMobile) this.contactItems[1].value = map.ContactMobile;
        if (map.ContactFax) this.contactItems[2].value = map.ContactFax;
        if (map.ContactEmail) this.contactItems[3].value = map.ContactEmail;
        if (map.ContactAddress) this.contactItems[4].value = map.ContactAddress;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }
};
</script>

<style lang="scss" scoped>
.download {
  width: 100%;
  background: linear-gradient(180deg, #14679f 0%, #0f4f7d 100%);
  padding-bottom: 40px;
}

.contact-panel {
  width: 1240px;
  max-width: calc(100% - 32px);
  margin: -28px auto 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 -8px 30px rgba(8, 28, 46, 0.12);
  position: relative;
  z-index: 1;
  padding: 40px 36px 48px;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.contact-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 18px;
  border: 1px solid #e6eef5;
  border-radius: 12px;
  background: #f8fbfe;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 24px rgba(20, 103, 159, 0.1);
  }

  i {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #1f6fab, #3aa0d8);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
  }

  h3 {
    margin: 0;
    font-size: 14px;
    color: #7a93a8;
    font-weight: 500;
  }

  p {
    margin: 6px 0 0;
    color: #17324a;
    font-size: 16px;
    line-height: 1.5;
  }
}

.contact-map-like {
  margin-top: 28px;
  padding: 36px 28px;
  border-radius: 14px;
  text-align: center;
  background:
    radial-gradient(circle at top right, rgba(58, 160, 216, 0.22), transparent 40%),
    linear-gradient(135deg, #0f2f4a, #1f6fab);

  h3 {
    margin: 0;
    color: #fff;
    font-size: 24px;
    font-weight: 600;
  }

  p {
    margin: 12px 0 22px;
    color: rgba(255, 255, 255, 0.86);
    font-size: 14px;
  }

  .phone-btn {
    display: inline-block;
    padding: 10px 22px;
    border-radius: 999px;
    background: #fff;
    color: #1f6fab;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
  }
}

@media (max-width: 900px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }

  .contact-panel {
    padding: 28px 18px 32px;
  }

  .contact-map-like {
    padding: 28px 18px;
  }

  .contact-map-like h3 {
    font-size: 20px;
  }
}
</style>
